var riot = require("riot");

riot.tag2('ahv-ownership-display', '<div class="ahv-display" id="ahv-ownership-display" show="{ownerships.length > 0}"> <div class="ahv-display-header"> Eierforhold </div> <table class="table table-bordered table-condensed table-hover"> <thead> <tr> <th>Eier</th> <th>Kjøpedato</th> <th>Andel</th> </tr> </thead> <tbody> <tr each="{ownership in ownerships}"> <td>{ownership.ownerName}</td> <td>{ownership.purchaseDate.ddmmyyyy}</td> <td>{ownership.fractionOwned}</td> </tr> </tbody> </table> <div class="ahv-display-footer">&nbsp;</div> </div>', '', '', function(opts) {
    require("./OwnershipDisplayMapper").init(this);
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/ownershipDisplay/ahv-ownership-display.tag
 ** module id = 75
 ** module chunks = 0
 **/